import LogoBlack from "../../../assets/logo/logo-black.svg?react";
import LogoWhite from "../../../assets/logo/logo-white.svg?react";
import { useIsUserSignedIn } from "../../../core_stores/useAuthStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { useAuthModal } from "../../../providers/AuthModalProvid";
import { useFreeTokensModal } from "../../../providers/FreeTokensModalProvider";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";
import { useTheme } from "../../../providers/ThemeProvider";

export function WelcomeAppBar() {
  const isUserSignedIn = useIsUserSignedIn();
  const isCompactView = useIsCompactView();
  const { theme } = useTheme();

  const { show: showAuthModal } = useAuthModal();

  async function onAuth() {
    await showAuthModal();
  }

  const Logo = theme === "dark" ? LogoWhite : LogoBlack;

  return (
    <div
      className={`${
        isCompactView ? "p-4" : "py-6 px-8"
      } z-30 w-full flex flex-row items-center justify-between`}
    >
      <a href="/" className="cursor-pointer">
        <Logo
          className={`${
            isCompactView ? "scale-[8]" : "scale-[10]"
          } origin-left z-20`}
        />
      </a>

      <div className="flex items-center gap-3">
        {!isCompactView && <FreeTokensBtn />}
        <PricingBtn />
        {isUserSignedIn ? null : isCompactView ? (
          <SingleSignInBtn onSignIn={onAuth} />
        ) : (
          <SignInSignUpBtn onSignIn={onAuth} onSignUp={onAuth} />
        )}
      </div>
    </div>
  );
}

function SingleSignInBtn({ onSignIn }: { onSignIn?: () => void }) {
  return (
    <button
      id="home-sign-in"
      onClick={onSignIn}
      className="bg-light-text dark:bg-dark-text text-light-surface-primary dark:text-dark-surface-primary font-semibold px-6 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:opacity-80 transition-opacity text-sm"
    >
      Sign in
    </button>
  );
}

function SignInSignUpBtn({
  onSignIn,
  onSignUp,
}: {
  onSignIn?: () => void;
  onSignUp?: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <button
        id="home-sign-in"
        onClick={onSignIn}
        className="text-light-text dark:text-dark-text font-medium px-4 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:bg-light-hover dark:hover:bg-dark-hover transition-colors text-sm"
      >
        Sign in
      </button>
      <button
        id="home-sign-up"
        onClick={onSignUp}
        className="bg-primary-blue text-white font-semibold px-4 py-2 flex items-center justify-center gap-2 rounded-full focus:outline-none hover:opacity-90 transition-opacity duration-300 text-sm"
      >
        Get started
      </button>
    </div>
  );
}

function FreeTokensBtn() {
  const { show: showFreeTokensModal } = useFreeTokensModal();

  return (
    <button
      id="home-free-tokens"
      onClick={showFreeTokensModal}
      className="text-light-text dark:text-dark-text font-medium px-4 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:bg-light-hover dark:hover:bg-dark-hover transition-colors text-sm"
    >
      Free tokens
    </button>
  );
}

function PricingBtn() {
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  return (
    <button
      id="home-pricing"
      onClick={openSubscriptionsModal}
      className="text-light-text dark:text-dark-text font-medium px-4 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:bg-light-hover dark:hover:bg-dark-hover transition-colors text-sm"
    >
      Pricing
    </button>
  );
}
